import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  encryptedString: validationNotEmpty("Encrypted String"),
  publicKey: validationNotEmpty("Public Key"),
});